// import styles
import { StyledBottomHeaderBox } from './BottomHeader.styles';

// import types
import { BottomHeaderProps } from './BottomHeader.types';

export default function BottomHeader({ children, sx = {} }: BottomHeaderProps) {
  return (
    <StyledBottomHeaderBox
      sx={{
        ...sx
      }}
    >
      {children}
    </StyledBottomHeaderBox>
  );
}
